import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UiTranslateModule } from '@fcom/ui-translate';
import { IconsModule, UiComponentsModule } from '@fcom/ui-components';

import { DirectiveModule } from '../../directives';
import { NavigationTriggerComponent } from './navigation/navigation-trigger/navigation-trigger.component';
import { ComponentsModule } from '../components.module';
import { PipesModule } from '../../pipes';
import { HeaderBoxesModule } from './header-boxes.module';

@NgModule({
  imports: [
    CommonModule,
    ComponentsModule,
    PipesModule,
    DirectiveModule,
    UiTranslateModule,
    IconsModule,
    UiComponentsModule,
    HeaderBoxesModule,
  ],
  declarations: [NavigationTriggerComponent],
  exports: [NavigationTriggerComponent, HeaderBoxesModule],
})
export class NavigationTriggerModule {}
